/** Solid red gum + white label for card “View Details” actions */
export const VIEW_DETAILS_COLORS = {
  background: "#892102",
  foreground: "#FFFFFF",
};
